import { render, staticRenderFns } from "./PatientCountList.vue?vue&type=template&id=edbcc324&scoped=true&"
import script from "./PatientCountList.vue?vue&type=script&lang=js&"
export * from "./PatientCountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbcc324",
  null
  
)

export default component.exports